import { Component, OnInit } from '@angular/core';
import {ProvidersService} from '../../services/providers.service';
import {ActivatedRoute} from '@angular/router';
import {ModalService} from 'ngx-dynamic-modal';
import {ProviderCallerIdUpdateComponent} from '../../modals/provider-caller-id-update/provider-caller-id-update.component';
import {AlertaService} from '../../../../../shared/services/alerta.service';

@Component({
  selector: 'app-provider-caller-id',
  templateUrl: './provider-caller-id.component.html',
  styleUrls: ['./provider-caller-id.component.scss']
})
export class ProviderCallerIdComponent implements OnInit {

    configs: Array<Object> = [];
    tempConfigs: Array<Object> = [];
    loading: boolean = true;

    providerName: string = '';
    pkProvider: number = 0;

    tableSearchText: string = '';

    constructor(private providersService: ProvidersService, private activatedRoute: ActivatedRoute, private modalService: ModalService, private alertaService: AlertaService) { }

    ngOnInit() {
        this.activatedRoute.params.subscribe(
            (params) => {
                this.loading = true;
                this.pkProvider = params['ppk'];
                this.providersService.getCallerIdsConfig(params['ppk']).subscribe(
                    (r) => {
                        this.configs = r;
                        this.tempConfigs = r;
                        this.loading = false;
                    }
                )
            }
        );

        this.activatedRoute.queryParams.subscribe(
            (queryParams) => {
                if(queryParams.hasOwnProperty('provider_name')){
                    this.providerName = queryParams['provider_name'];
                }
            }
        )
    }

    newCallerIdConfig(): void {
        this.modalService.addDynamicComponent(ProviderCallerIdUpdateComponent, {'provider_pk' : this.pkProvider}, (res) => {
            this.applyCallback();
        } );
    }

    editCallerIdConfig(row: Object): void {
        this.modalService.addDynamicComponent(ProviderCallerIdUpdateComponent, {'provider_pk' : this.pkProvider, 'object' : row}, (res) => {
            this.applyCallback();
        });
    }

    enableConfig(row: Object): void {
        const activeValue = (row['active'] == '1') ? '0' : '1';
        const message = (row['active'] == '1') ? 'Config disabled successfully' : 'Config enabled successfully';

        this.loading = true;
        this
            .providersService
            .patchCallerIdConfig(row['pk'], {'active' : activeValue})
            .subscribe(
                (r) => {
                    const idx = this.configs.findIndex( (o) => { return o['pk'] == row['pk']; });
                    this.configs[idx]['active'] = activeValue;
                    this.alertaService.addAlert('success', message);
                    this.loading = false;
                }
            )
    }

    updateFilter(event) {
        this.tableSearchText = event.target.value.toLowerCase();
        const temp = this.tempConfigs.filter((d) => {
            return d['caller_id_portal'].toLowerCase().indexOf(this.tableSearchText) !== -1 || d['caller_id'].indexOf(this.tableSearchText) !== -1 || !this.tableSearchText;
        });

        this.configs = temp;
    }

    deleteCallerIdConfig(row: Object): void {
        this
            .alertaService
            .addAlert('confirm', 'Caller id config will be removed. Are you sure?')
            .then(
                (r) => {
                    if(r['value']){
                        this.loading = true;
                        this.providersService.deleteCallerIdConfig(row['pk']).subscribe(
                            (r) => {
                                this.loading = false;
                                const idx = this.configs.findIndex( (o) => { return o['pk'] == row['pk']; });
                                this.configs.splice(idx, 1);
                                this.alertaService.addAlert('success', 'Caller id config removed successfully');
                            }
                        )
                    }
                }
            )
        ;
    }

    protected applyCallback(): void {
        this.loading = true;
        this.providersService.getCallerIdsConfig(this.pkProvider).subscribe(
            (r) => {
                this.configs = r;
                this.tempConfigs = r;
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/providers/components/provider-caller-id/provider-caller-id.component.ts